/**
 * Open a URL in the device's external browser.
 *
 * In the Capacitor iOS/Android webview, `window.open` with `target="_blank"`
 * routes http(s) URLs to the system browser (Safari / Chrome) rather than
 * navigating the app's own webview - the clearest "you're leaving the app"
 * signal. On the web build it simply opens a new tab. `noopener,noreferrer`
 * keeps the opened page from reaching back into our window.
 */
export function openExternal(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}
